import loyaltyProgramConstants from 'constants/loyaltyProgram';

export const BENEFITS = [
  { key: 'access_luxity', label: 'Access to Luxity' },
  { key: 'free_shipping', label: 'Free Domestic & International Shipping' },
  { key: 'add_interests', label: 'Add Interests' },
  { key: 'email_notifications', label: 'Email Product Notifications' },
  { key: 'whatsapp_notifications', label: 'WhatsApp Product Notifications' },
  { key: 'early_access', label: '24 Hour Early Access to New Products' },
  { key: 'private_shopping', label: 'Private Shopping Experience' },
  { key: 'welcome_package', label: 'Xclusive Event Invites' },
  { key: 'annual_coupon', label: 'Xclusive 10% Off Coupon' },
];

const REGULAR_BENEFITS = [
  'access_luxity',
  'free_shipping',
  'add_interests',
  'email_notifications',
];

const EARLY_ACCESS_BENEFITS = [
  ...REGULAR_BENEFITS,
  'whatsapp_notifications',
  'early_access',
];

const TIER_BENEFITS = {
  [loyaltyProgramConstants.STATUS_EARLY_ACCESS]: EARLY_ACCESS_BENEFITS,
  [loyaltyProgramConstants.STATUS_EXCLUSIVE]: BENEFITS.map(
    (benefit) => benefit.key,
  ),
};

export const getTierBenefits = (status) =>
  TIER_BENEFITS[status] || REGULAR_BENEFITS;
